import { render, staticRenderFns } from "./addPurchaseReturns.vue?vue&type=template&id=7c428841&scoped=true"
import script from "./addPurchaseReturns.vue?vue&type=script&lang=js"
export * from "./addPurchaseReturns.vue?vue&type=script&lang=js"
import style0 from "./addPurchaseReturns.vue?vue&type=style&index=0&id=7c428841&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c428841",
  null
  
)

export default component.exports